<template>
    <v-container xs12 mx-0 px-0 id="pitch-analyzer" :class="this.uncertainPitch?'greyed-out-pitch':''">
      <v-layout >
        <v-flex xs5 >  
          <v-btn v-if="false" :disabled="!mic"  @click.native="whichAudio=0" fab dark color="primary" >
            <v-icon dark>mic</v-icon>
          </v-btn> 
          <button mt-0 fab dark class="btn btn--floating theme--dark blue"
                @mousedown="whichAudio=0;  "
                @touchstart="whichAudio=0; "
                @mouseup="whichAudio=null;  "
                @touchend="whichAudio=null; "> 
                <v-icon dark>mic</v-icon>
          </button>   
          <v-btn-toggle v-model="whichAudio" v-if="false" >     
            <v-btn :disabled="!mic">
              Mic
            </v-btn>
            
            <!-- 
            <v-btn v-if="false" v-for="s,i in testWavUrls":key="i">
              Test {{i}}
            </v-btn>
            -->
          </v-btn-toggle>
            <span class="note-name mic-note">{{note.name}}</span>
            <span class="over-under">
              <span class="over-under-row" v-html="note.sharp"></span>
              <span class="over-under-row" v-html="note.octave"></span>
            </span>
        </v-flex>
        <v-flex xs5 mt-0>  
          {{note.pitch}} Hz
          <div  :style="{width: Math.log(note.pitch/440)/Math.log(2)*12+69+'%', height:'40px', backgroundColor:'#2D9CDB',
          transition: 'width 0.05s linear'}"></div><div v-if="false" :style="{height:'40px', width: Math.log(65.41)/Math.log(2)*50-200+'px', display:'inline-block'}">&nbsp;</div>
          <div v-if="false" v-for="i in 5" :key="i" class="octave-divider">C{{i+1}}</div>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import pitchfinder from 'pitchfinder';
import wav from 'wav-decoder'

export default {
  data() {
    const fftSize = 2048; //number of samples analyzed at once
    return {
      noteNames: ['C', 'C', 'D', 'D', 'E', 'F', 'F', 'G', 'G', 'A', 'A', 'B'],
      noteSharps: ['&nbsp;', '♯', '&nbsp;', '♯', '&nbsp;', '&nbsp;', '♯', '&nbsp;', '♯', '&nbsp;', '♯', '&nbsp;'],

      // findPitch: pitchfinder.AMDF(),           // reliable but slow and has high uncertainty
      // findPitch: pitchfinder.DynamicWavelet(), // fast but unreliable at low frequencies 
      findPitch: pitchfinder.YIN(),            // balanced speed/reliability

      context: new (window.AudioContext||window.webkitAudioContext)(),
      mic: null,
      analyzer: null,
      fftSize: fftSize,
      buffer: new Uint8Array(fftSize),
      note: {
        pitch: '—', //<-- em dash
        name: '-',
        sharp: '&nbsp;',
        octave: '&nbsp;'
      },
      uncertainPitch: true,
      console:console,
      testWavUrls: ['/audio/c4.wav','/audio/sweep.wav','/audio/sweep2.wav'],
      testAudio: [],
      
      keepGoing: true,
      whichAudio: null,
      repeatId: -1
    };
  },
  mounted () {
    const that = this;
    
    if (!this.analyzer) {
      this.analyzer = this.context.createAnalyser();
      this.analyzer.fftSize = this.fftSize;
      this.analyzer.connect(this.context.destination)
    }
    this.niceInterval(this.updateNote, 100, function (){return that.keepGoing});

    let getMic;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      getMic = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices)({audio: true})
    } else if (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
      const getUserMedia = (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia)
      getMic = new Promise(function (callback, err) {getUserMedia({audio: true}, callback, err);})
    }
    if (getMic) {
      getMic.then(function(mic) {that.mic = that.context.createMediaStreamSource(mic);}).catch(console.log);
    }
    // things that depend on this.mic should be disabled by default, only activating if getMic succeeds

    if (this.testAudio.length == 0) {
      for (let i=0; i < this.testWavUrls.length; i++) {
        let req = new XMLHttpRequest();
        req.open('GET', this.testWavUrls[i], true);
        req.responseType = 'arraybuffer';
        req.onload = function() {
          wav.decode(req.response).then( function(data) {
            that.testAudio[i] = that.context.createBuffer(2, 44100*5, 44100);
            const channel0 = that.testAudio[i].getChannelData(0);
            const channel1 = that.testAudio[i].getChannelData(1);
            channel0.set(data.channelData[0],0);
            channel1.set(data.channelData[1],0);
          });
        }
        req.send();
      }
    }
  },
  destroyed() {
    this.keepGoing=false;
    this.context.close();
  },
  methods: {
    niceInterval(callback, delay, shouldRun=function(){return true}, storeId = function(){}) {
      if (shouldRun()) {
        callback();
        const that=this;
        storeId(setTimeout(function(){that.niceInterval(callback, delay, shouldRun)}, delay));
      }
    },
    updateNote() {this.context.resume().then(()=>{
      this.analyzer.getByteTimeDomainData(this.buffer)
      this.getNote(this.ncc(this.buffer));
    });},
    getNote(pitch) {
      if (pitch != null && pitch != 17640) {
        this.uncertainPitch = false;
        const n = Math.round(Math.log(pitch/27.5)/Math.log(2)*12+9);
        this.note = {
          pitch: (Math.round(pitch*10)/10),
          name: this.noteNames[n%12],
          sharp: this.noteSharps[n%12],
          octave: Math.floor(n/12)
        };
      } else {
        this.uncertainPitch = true;
      }
    },
    test() {
      this.context.resume().then(()=>{
        const source = this.context.createBufferSource();
        source.buffer = this.testAudio[this.whichAudio-1];
        source.connect(this.analyzer);
        source.start();
      });
    },
    // normalized cross-correlation
    ncc (buffer, sampleRate=false) {
      if (!sampleRate) {
        sampleRate = this.context.sampleRate
      }
      const n = this.fftSize/2
      let bestR = 0, bestK = -1;

      let leftNorm = 0, rightNorm = 0;

      for (let i = 0; i < n; i++) {
        leftNorm += (buffer[i]-128)*(buffer[i]-128);
        rightNorm += (buffer[i+31]-128)*(buffer[i+31]-128);
      }
      if (leftNorm < 16*n) {
        return null;
      }

      let close = false;
      // k = 16 corresponds to ~ F7; k=1000 corresponds to ~ F1
      for (let k = 16; k <= 1000; k++){
        let sum = 0;
        for(let i = 0; i < n; i++){
          sum += ((buffer[i]-128) * (buffer[i+k] - 128));
        }

        rightNorm -= (buffer[k-1]-128)*(buffer[k-1]-128);
        rightNorm += (buffer[n+k]-128)*(buffer[n+k]-128);
        let norm = Math.sqrt(leftNorm*rightNorm)
        let r = sum/norm;
        if (r > bestR) {
          bestR = r;
          bestK = k;
          // this threshold is so that we don't get half or a third of the main frequency
          // which happens to be a slightly better match
          // but we also don't want it to accept a slightly-too-high frequency
          // hence the "close" variable
          if (bestR > 0.90) {
            if (k == 16) {
              return null;
            }
            close = true;
          }
        } else if (close) {
          break;
        }
      }
      // don't return anything if confidence is low
      if(bestR > 0.0025) {
        return sampleRate / bestK;
      } else {
        return null;
      }
    }
  },
  watch: {
    whichAudio: function() {
      this.context.resume().then(()=>{
        clearTimeout(this.repeatId);
        const that = this;

        if (this.mic) { 
          this.mic.disconnect();
        }
        // whichAudio == 0 is mic, others are test clips
        if (this.whichAudio!= 0) {
          this.analyzer.connect(this.context.destination);
          this.niceInterval(this.test, 8000,
            function() {return that.whichAudio && that.keepGoing;},
            function(id) {that.repeatId=id;});
        } else {
          this.analyzer.disconnect();
          this.mic.connect(this.analyzer);
        }
      });
    }
  }
}
</script>
<style scoped>
  .note-name{
    height: 100%;
    vertical-align: middle;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.75rem;
    font-weight: bold;
  }
  .mic-note{
    font-size: 2.75rem;
    margin-left: 1rem;
  }
</style>
<style>
</style>


// WEBPACK FOOTER //
// src/components/PitchAnalyzer.vue